import { Button } from '@talentmesh/ui/components/button';
import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import UIStrings from '../utils/UIStrings';

interface ApplyButtonProps {
    onBoardUrl: string;
}

function ApplyButton({ onBoardUrl }: ApplyButtonProps): React.JSX.Element {
    const onClickHandler = () => {
        window.open(onBoardUrl, '_blank');
    };

    return (
        <Button type="button" onClick={onClickHandler} className={isMobile || isTablet ? 'w-44 grow' : 'grow'}>
            {UIStrings.ApplyNow}
        </Button>
    );
}

export default ApplyButton;
